import { checkIsTextTruncated } from '../metrics/ui';
import { validate } from '../metrics/validation';
import configState from '../state/config';
import { getStarlingKey } from '../utils/starling';
import { checkIsTextExcluded } from './exclude';
import { shouldReportSampling } from './sampling';
import { checkVisibility } from './visibility';
import { getXPath } from './xPath';
var SDK_VERSION = '0.0.0';
var EVENT_NAME = 'btm_copywriting_show';
var seenKey = new Set();
var excludedTags = new Set([
    'SCRIPT',
    'NOSCRIPT',
    'STYLE',
    'META',
    'TITLE',
    'LINK',
    'BASE',
    'HEAD',
    'TEXTAREA',
]);
export function report(_a) {
    var _b, _c;
    var rawText = _a.text, node = _a.node;
    try {
        var text = rawText.trim();
        var parentEl = node.parentElement;
        // Exclude <script> and <noscript>
        if (excludedTags.has((_b = parentEl === null || parentEl === void 0 ? void 0 : parentEl.tagName) !== null && _b !== void 0 ? _b : '')) {
            return;
        }
        if (checkIsTextExcluded(text)) {
            return;
        }
        var _d = validate(text), isValid = _d.value, invalidReason = _d.reason;
        if (isValid && !shouldReportSampling())
            return;
        var starling = getStarlingKey(text);
        if (!checkVisibility(parentEl)) {
            return;
        }
        var _e = (_c = configState.config) !== null && _c !== void 0 ? _c : {}, teaCollectEvent = _e.teaCollectEvent, btmInstance = _e.btmInstance;
        var xPath = getXPath(parentEl);
        var btmPoints = btmInstance === null || btmInstance === void 0 ? void 0 : btmInstance.getFullBtmInfo(parentEl).btm;
        var _f = window.location, host = _f.host, rawPathname = _f.pathname;
        var pathname = sanitizePath(rawPathname);
        var params_1 = {
            version: SDK_VERSION,
            btm: btmPoints,
            text: text,
            starling_key: starling === null || starling === void 0 ? void 0 : starling.key,
            starling_lang: starling === null || starling === void 0 ? void 0 : starling.lang,
            is_valid: isValid,
            invalid_reason: invalidReason,
            ui_truncation: checkIsTextTruncated(node),
            path: pathname,
            host: host,
            x_path: xPath,
        };
        // prevent double reporting
        var reportKey = Object.keys(params_1)
            .reduce(function (acc, cur) {
            if (cur !== 'x_path' && params_1[cur] != null) {
                acc.push("".concat(cur, ":").concat(params_1[cur]));
            }
            return acc;
        }, [])
            .join(';');
        if (seenKey.has(reportKey)) {
            return;
        }
        seenKey.add(reportKey);
        teaCollectEvent === null || teaCollectEvent === void 0 ? void 0 : teaCollectEvent(EVENT_NAME, params_1);
    }
    catch (_) {
        // empty
    }
}
export var sanitizePath = function (pathname) {
    // Replace any numeric or dynamic segment in the path with ":id"
    return pathname.replace(/\/\d+/g, '/:id');
};
